import { CategoryInventoryScan } from "@gull";
import { lazy, useContext } from "react";
// import DashboardBilling from "./DashboardBilling";
// import ChiffreAffaires from "./ChiffreAffaires";
const DashboardBilling = lazy(() => import("./DashboardBilling"));
const ChiffreAffaires = lazy(() => import("./ChiffreAffaires"));
const CreateBillingGeneral = lazy(() => import("./CreateComp/CreateBillingGeneral"));
const CreateFormAddItems = lazy(() => import("./CreateComp/CreateFormAddItems"));
const SearchBilling = lazy(() => import("./SearchBilling"));
// const EndBilling = lazy(() => import("./EndBilling"));
const TemplateBilling = lazy(() => import("./TemplateBilling"));
const TemplateEmail = lazy(() => import("./TemplateEmail"));
const RecurrenceBilling = lazy(() => import("./RecurrenceBilling"));
const NotificationListErp = lazy(() => import("./Notification/NotificationListErp"));
const NotificationDetailErp = lazy(() => import("./Notification/NotificationDetailErp"));
const LicenceNotificationDetail = lazy(() => import("../notifications/LicenceNotificationDetail"));
const HistoriqueDetail = lazy(() => import("./Historique/HistoriqueDetail"));
const MainViewDocument = lazy(() => import("./DetailDocumentComp/MainViewDocument"));
const FacturationReport = lazy (()=> import("./ReportPbi/FacturationReport"))
const DetailDossier = lazy (()=> import("./Dossier/DetailDossier"))
const ConvertDocToPo = lazy (()=> import("./ConvertDocToPo/ConvertDocToPo"))
const ConvertDocToReturnNote = lazy (()=> import("./ConvertDocToReturnNote/ConvertDocToReturnNote"))
const ConvertDocToCreditNote = lazy (()=> import("./ConvertDocToCreditNote/ConvertDocToCreditNote"))
const ConvertDocToCreditNoteBuy = lazy (()=> import("./ConvertDocToCreditNoteBuy/ConvertDocToCreditNoteBuy"))
const ConvertDocToDeliveryNote = lazy (()=> import("./ConvertDocToDeliveryNote/ConvertDocToDeliveryNote"))
const MatchIdsInterne = lazy (()=> import("./MatchIdsInterne/MatchIdsInterne"))
const Client = lazy (()=> import("./Client/Client"))
const ClientFacturationGeneral = lazy (()=> import("./Client/ClientFacturationGeneral"))
const ExceptionRefacturation = lazy (()=> import("./Refacturation/ExceptionRefacturation"))
const ExceptionRefacturationDetail = lazy (()=> import("./Refacturation/ExceptionRefacturationDetail"))
const FactureInterSociete = lazy (()=> import("./Refacturation/FactureInterSociete"))

const facturationRoutes = [
    {
        id: "facturation_dashboard",
        name: "[Facturation] Dashboard",
        path: "/invoice/dashboard",
        component: DashboardBilling
    },
    {
        path: "/invoice/search",
        component: SearchBilling
    },
    {
        path: "/invoice/convert-to-purchase-order/:id",
        component: ConvertDocToPo
    },
    {
        path: "/invoice/convert-to-return-order/:id",
        component: ConvertDocToReturnNote
    },
    {
        path: "/invoice/convert-to-credit-note/:id",
        component: ConvertDocToCreditNote
    },
    {
        path: "/invoice/convert-to-credit-note-buy/:id",
        component: ConvertDocToCreditNoteBuy
    },
    {
        path: "/invoice/convert-to-delivery-note/:id",
        component: ConvertDocToDeliveryNote
    },
    {
        path: "/invoice/document/create",
        component: CreateBillingGeneral
    },
    {
        path: "/invoice/document/create-add-items/:id",
        component: CreateFormAddItems
    },
    // {
    //     path: "/invoice/invoice/end/:id",
    //     component: EndBilling
    // },
    {
        path: "/invoice/invoice/recurrence",
        component: RecurrenceBilling
    },
    {
        path: "/invoice/invoice/template",
        component: TemplateBilling
    },
    {
        path: "/invoice/email/template",
        component: TemplateEmail
    },
    {
        path: "/invoice/notifications/list",
        component: NotificationListErp
    },
    {
        path: "/invoice/notifications/detail/:id",
        component: NotificationDetailErp
    },
    {
        path: "/invoice/notifications/licence-notification/:licenceNotificationId",
        component: LicenceNotificationDetail
    },
    {
        path: "/invoice/historique/edit/:id",
        component: HistoriqueDetail
    },
    {
        path: "/invoice/details/:id",
        component: MainViewDocument
    },
    {
        path: "/invoice/chiffre_affaires",
        component: ChiffreAffaires
    },
    {
        path: "/invoice/report",
        component: FacturationReport
    },
    {
        path: "/invoice/folder-detail/:id",
        component: DetailDossier
    },
    {
        path: "/invoice/internal-id-match",
        component: MatchIdsInterne
    },
    {
        exact:true,
        path: "/invoice/client",
        component: ClientFacturationGeneral
    },
    {
        exact:true,
        path: "/invoice/client/detail/:id",
        component: Client
    },
    {
        exact:true,
        path: "/invoice/exception_refacturation",
        component: ExceptionRefacturation
    },
    {
        exact:true,
        path: "/invoice/exception_refacturation/detail/:id",
        component: ExceptionRefacturationDetail
    },
    {
        exact:true,
        path: "/invoice/facture_inter_societe",
        component: FactureInterSociete
    },
  ];
  
  export default facturationRoutes; 